import React from 'react';

const cleanListingTitle = (value) => (value || 'Airbnb listing').split('·')[0].trim();

export const HostListingPreviewCard = ({ preview }) => {
  if (!preview) {
    return null;
  }

  return (
    <div
      className="premium-card"
      data-testid="host-listing-preview-card"
      style={{ width: '100%', maxWidth: 342, padding: 12, marginTop: 12, display: 'flex', gap: 12, alignItems: 'center' }}
    >
      <div
        data-testid="host-listing-preview-image-shell"
        style={{ width: 88, height: 72, borderRadius: 18, overflow: 'hidden', background: 'var(--surface-2)', flexShrink: 0 }}
      >
        {preview.image ? (
          <img
            src={preview.image}
            alt={preview.title || 'Listing preview'}
            data-testid="host-listing-preview-image"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : null}
      </div>

      <div style={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <p
          data-testid="host-listing-preview-title"
          style={{
            fontFamily: "'Inria Serif', serif",
            fontSize: 17,
            fontWeight: 700,
            color: 'var(--text)',
            margin: 0,
            lineHeight: 1.2,
            wordBreak: 'break-word',
          }}
        >
          {cleanListingTitle(preview.title)}
        </p>
        {preview.location_label ? (
          <p
            data-testid="host-listing-preview-location"
            style={{ fontFamily: "'Inria Serif', serif", fontSize: 14, color: 'var(--text-2)', margin: 0, lineHeight: 1.3 }}
          >
            {preview.location_label}
          </p>
        ) : null}
      </div>
    </div>
  );
};
